import * as React from "react"
import * as styles from "../styles/footer.module.scss"

const Footer = () => (
  <footer className={styles.addressSection}>Tavčarjeva ulica 13,<br />1000 Ljubljana</footer>
)

export default Footer
